import { render, staticRenderFns } from "./LessonSliderComponent.vue?vue&type=template&id=3e642995&scoped=true&"
import script from "./LessonSliderComponent.vue?vue&type=script&lang=js&"
export * from "./LessonSliderComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonSliderComponent.vue?vue&type=style&index=0&id=3e642995&prod&lang=scss&scoped=true&"
import style1 from "./LessonSliderComponent.vue?vue&type=style&index=1&id=3e642995&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e642995",
  null
  
)

export default component.exports